<!-- 作业调控 -->
<template>
	<div>
		<div class="index" v-show="!detail.show">
			<div class="title">
				<span>{{ $route.name }}</span>
			</div>
			<div>
				<el-form :inline="true" :model="queryParams" label-width="45px">
					<el-form-item label="班级:">
						<!-- 管理员、学科组长 -->
						<el-select
							v-if="isAdmin"
							v-model="queryParams.gradeNumber"
							clearable
							placeholder="请选择"
							class="label"
						>
							<el-option
								v-for="item in GradeList"
								:key="item.gradeNumber"
								:label="item.gradeName"
								:value="item.gradeNumber"
							>
							</el-option>
						</el-select>
						<!-- 班主任、普通教师 -->
						<el-select
							v-else
							v-model="queryParams.classId"
							clearable
							placeholder="请选择"
							class="label"
						>
							<el-option
								v-for="item in classList"
								:key="item.classId"
								:label="item.className"
								:value="item.classId"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="作业日期:" label-width="75px" style="margin-left:20px">
						<el-date-picker v-model="queryParams.homeworkDate" type="date" placeholder="请选择">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="" style="float:right">
						<el-button type="primary" size="small" @click="searchFun()">查询</el-button>
					</el-form-item>
				</el-form>

				<!-- 作业表 -->
				<div v-if="tableData">
					<el-table :data="tableData" border style="width: 100%">
						<el-table-column
							prop="className"
							label="班级"
							width="86"
							align="center"
							label-class-name="first-title"
						>
						</el-table-column>
						<el-table-column
							label="预计时长"
							width="75"
							align="center"
							label-class-name="top-title"
						>
							<el-table-column
								prop="expectedTime"
								label="(分钟)"
								width="75"
								align="center"
								label-class-name="sub-title"
							>
								<template slot-scope="scope">
									<div
										:class="{ isOutLimit: scope.row.estimateDuration > scope.row.limitDuration }"
									>
										<span class="num"> {{ scope.row.estimateDuration }}</span>
									</div>
									<div v-if="scope.row.estimateDuration > scope.row.limitDuration">
										<span class="out-limit"> 超标</span>
									</div>
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column
							label="实际时长"
							width="75"
							align="center"
							label-class-name="top-title"
						>
							<el-table-column
								prop="practicalDuration"
								label="(分钟)"
								width="75"
								align="center"
								label-class-name="sub-title"
							>
								<template slot-scope="scope">
									<div
										:class="{ isOutLimit: scope.row.practicalDuration > scope.row.limitDuration }"
									>
										<span class="num"> {{ scope.row.practicalDuration }}</span>
									</div>
									<div v-if="scope.row.practicalDuration > scope.row.limitDuration">
										<span class="out-limit"> 超标</span>
									</div>
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column
							label="标准上限时长"
							width="100"
							align="center"
							label-class-name="top-title"
						>
							<el-table-column
								prop="limitDuration"
								label="(分钟)"
								width="100"
								align="center"
								label-class-name="sub-title"
							>
							</el-table-column>
						</el-table-column>
						<el-table-column label="语文" width="74" class="bdb" label-class-name="top-title">
							<el-table-column
								prop="jcsub01"
								label="(分钟)"
								width="74"
								align="center"
								class="bdb"
								label-class-name="sub-title"
							>
								<template slot-scope="scope" v-if="scope.row.jcsub01">
									<div
										:class="{ 'to-detail': scope.row.jcsub01.timeOnWeek }"
										@click="toDetail(scope.row.jcsub01.homeworkId)"
									>
										<div class="subjectTime">
											{{ scope.row.jcsub01.estimateDuration }}
										</div>
										<div class="teacherName">{{ scope.row.jcsub01.teacherName }}</div>
										<!-- <div class="timeOnWeek">本周第{{ scope.row.jcsub01.timeOnWeek }}次作业</div> -->
									</div>
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column label="数学" width="74" class="bdb" label-class-name="top-title">
							<el-table-column
								prop="jcsub02"
								label="(分钟)"
								width="74"
								align="center"
								class="bdb"
								label-class-name="sub-title"
							>
								<template slot-scope="scope" v-if="scope.row.jcsub02">
									<div
										:class="{ 'to-detail': scope.row.jcsub02.timeOnWeek }"
										@click="toDetail(scope.row.jcsub02.homeworkId)"
									>
										<div class="subjectTime">{{ scope.row.jcsub02.estimateDuration }}</div>
										<div class="teacherName">{{ scope.row.jcsub02.teacherName }}</div>
										<!-- <div class="timeOnWeek">本周第{{ scope.row.jcsub02.timeOnWeek }}次作业</div> -->
									</div>
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column label="英语" width="74" label-class-name="top-title">
							<el-table-column
								prop="jcsub03"
								label="(分钟)"
								width="74"
								align="center"
								label-class-name="sub-title"
							>
								<template slot-scope="scope" v-if="scope.row.jcsub03">
									<div
										:class="{ 'to-detail': scope.row.jcsub03.timeOnWeek }"
										@click="toDetail(scope.row.jcsub03.homeworkId)"
									>
										<div class="subjectTime">{{ scope.row.jcsub03.estimateDuration }}</div>
										<div class="teacherName">{{ scope.row.jcsub03.teacherName }}</div>
										<!-- <div class="timeOnWeek">本周第{{ scope.row.jcsub03.timeOnWeek }}次作业</div> -->
									</div>
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column label="物理" width="74" label-class-name="top-title">
							<el-table-column
								prop="jcsub13"
								label="(分钟)"
								width="74"
								align="center"
								label-class-name="sub-title"
							>
								<template slot-scope="scope" v-if="scope.row.jcsub13">
									<div
										:class="{ 'to-detail': scope.row.jcsub13.timeOnWeek }"
										@click="toDetail(scope.row.jcsub13.homeworkId)"
									>
										<div class="subjectTime">{{ scope.row.jcsub13.estimateDuration }}</div>
										<div class="teacherName">{{ scope.row.jcsub13.teacherName }}</div>
										<!-- <div class="timeOnWeek">本周第{{ scope.row.jcsub13.timeOnWeek }}次作业</div> -->
									</div>
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column label="化学" width="74" label-class-name="top-title">
							<el-table-column
								prop="jcsub14"
								label="(分钟)"
								width="74"
								align="center"
								label-class-name="sub-title"
							>
								<template slot-scope="scope" v-if="scope.row.jcsub14">
									<div
										:class="{ 'to-detail': scope.row.jcsub14.timeOnWeek }"
										@click="toDetail(scope.row.jcsub14.homeworkId)"
									>
										<div class="subjectTime">{{ scope.row.jcsub14.estimateDuration }}</div>
										<div class="teacherName">{{ scope.row.jcsub14.teacherName }}</div>
										<!-- <div class="timeOnWeek">本周第{{ scope.row.jcsub14.timeOnWeek }}次作业</div> -->
									</div>
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column label="生物" width="74" label-class-name="top-title">
							<el-table-column
								prop="jcsub15"
								label="(分钟)"
								width="74"
								align="center"
								label-class-name="sub-title"
							>
								<template slot-scope="scope" v-if="scope.row.jcsub15">
									<div
										:class="{ 'to-detail': scope.row.jcsub15.timeOnWeek }"
										@click="toDetail(scope.row.jcsub15.homeworkId)"
									>
										<div class="subjectTime">{{ scope.row.jcsub15.estimateDuration }}</div>
										<div class="teacherName">{{ scope.row.jcsub15.teacherName }}</div>
										<!-- <div class="timeOnWeek">本周第{{ scope.row.jcsub15.timeOnWeek }}次作业</div> -->
									</div>
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column label="历史" width="72" label-class-name="top-title">
							<el-table-column
								prop="jcsub11"
								label="(分钟)"
								width="72"
								align="center"
								label-class-name="sub-title"
							>
								<template slot-scope="scope" v-if="scope.row.jcsub11">
									<div
										:class="{ 'to-detail': scope.row.jcsub11.timeOnWeek }"
										@click="toDetail(scope.row.jcsub11.homeworkId)"
									>
										<div class="subjectTime">{{ scope.row.jcsub11.estimateDuration }}</div>
										<div class="teacherName">{{ scope.row.jcsub11.teacherName }}</div>
										<!-- <div class="timeOnWeek">本周第{{ scope.row.jcsub11.timeOnWeek }}次作业</div> -->
									</div>
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column label="思想品德" label-class-name="top-title">
							<el-table-column
								prop="jcsub08"
								label="(分钟)"
								align="center"
								label-class-name="sub-title"
							>
								<template slot-scope="scope" v-if="scope.row.jcsub08">
									<div
										:class="{ 'to-detail': scope.row.jcsub08.timeOnWeek }"
										@click="toDetail(scope.row.jcsub08.homeworkId)"
									>
										<div class="subjectTime">{{ scope.row.jcsub08.estimateDuration }}</div>
										<div class="teacherName">{{ scope.row.jcsub08.teacherName }}</div>
										<!-- <div class="timeOnWeek">本周第{{ scope.row.jcsub08.timeOnWeek }}次作业</div> -->
									</div>
								</template>
							</el-table-column>
						</el-table-column>
					</el-table>
					<!-- 分页组件 -->
					<div class="pagination">
						<el-pagination
							background
							:current-page="pageNum"
							:page-sizes="[10, 20, 50, 100]"
							:page-size="pageSize"
							:total="totalPage"
							layout="total,prev, pager, next,jumper,sizes"
							@size-change="sizeChangeHandle"
							@current-change="currentChangeHandle"
						></el-pagination>
					</div>
				</div>
				<!-- 未登记作业 -->
				<div v-else class="no-regulation">
					<img src="./img/no-regulation.png" />
					<p>暂未数据</p>
				</div>
			</div>
		</div>

		<Detail :info="detail.info" v-if="detail.show" @to-index="toIndex"></Detail>
	</div>
</template>
<script>
	import { getControlList, getSchoolControlList } from "@/api/school/index.js";
	import dayjs from "dayjs";
	import localForage from "localforage";
	export default {
		components: {
			Detail: () => import("./detail.vue"),
		},
		data() {
			return {
				userType: "", //用户角色
				isAdmin: false, //是否是管理员或学科组长
				classList: [], //班级列表
				pageNum: 1,
				pageSize: 10,
				totalPage: 0,
				subjectList: [],
				tableData: [],
				queryParams: {
					homeworkDate: "",
					classId: "", //班级id
					gradeNumber: "", //年级id
				},
				detail: {
					info: {},
					show: false,
				},
			};
		},
		watch: {},
		activated() {
			this.getDataList();
			this.queryParams.homeworkDate = dayjs().format("YYYY-MM-DD");
		},
		created() {
			this.getCommonList();
			this.getUserType();
		},

		methods: {
			async getCommonList() {
				this.classList = await localForage.getItem("classList");
				this.classList.unshift({ classId: "", className: "全部" });
			},
			// 获取用户角色
			getUserType() {
				this.userType = sessionStorage.userType;
				console.log("this.userType--", this.userType);
				if (this.userType.search(/(G1|G3)/) > -1) {
					this.isAdmin = true;
				}
			},
			//获取作业调控列表
			async getDataList() {
				console.log("this.queryParams.homeworkDate--", this.queryParams.homeworkDate);
				let ss = sessionStorage;
				let params = {
					loginPlatformCode: ss.loginPlatformCode,
					platformCode: ss.platformCode,
					usessionid: ss.usessionid,
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					homeworkDate: dayjs(this.queryParams.homeworkDate || Date.now()).format("YYYY-MM-DD"),
				};
				let res;
				if (this.isAdmin) {
					//管理员、学科组长
					params.gradeNumber = this.queryParams.gradeNumber;
					res = await getSchoolControlList(params);
					console.log("全校作业调控列表--", res);
				} else {
					//班主任、普通教师
					params.classId = this.queryParams.classId;
					res = await getControlList(params);
					console.log("作业调控列表--", res);
				}
				if (!res) return;
				res.list?.forEach((item) => {
					item.homeworkDate = dayjs(item.homeworkDate).format("YYYY-MM-DD");
					item.createTime = dayjs(item.createTime).format("YYYY-MM-DD HH:mm");
					item.subjects.forEach((subject) => {
						item[subject.subjectId] = subject;
					});
				});
				this.tableData = res.list;
				this.totalPage = res.total;
			},
			searchFun() {
				this.pageNum = 1;
				this.getDataList();
			},
			sizeChangeHandle(val) {
				this.pageSize = val;
				this.getDataList();
			},
			currentChangeHandle(val) {
				this.pageNum = val;
				this.getDataList();
			},
			toDetail(id) {
				console.log("作业调控--", id);
				this.$router.push({
					path: "/task/regulation/registerDetail",
					query: { homeworkId: id },
				});
			},
			toIndex() {
				this.detail.show = false;
			},
		},
		mounted() {},
	};
</script>
<style lang="less" scoped>
	.index {
		width: 100%;
		padding: 0px 30px 30px 30px;

		.title {
			height: 68px;
			line-height: 80px;
			border-bottom: 1px solid #eaeaea;
			margin-bottom: 20px;
			display: flex;
			justify-content: flex-start;
			> span {
				font-family: "PingFang SC Bold";
				font-weight: 500;
				font-size: 20px;
				text-align: left;
				color: #333;
				margin-right: 30px;
			}
		}
		.no-regulation {
			text-align: center;
			img {
				margin: 128px 0 40px;
				width: 228px;
				height: 120px;
			}
			p {
				color: #333;
				span {
					color: #65a1e5;
					cursor: pointer;
				}
			}
		}
		::v-deep .isOutLimit {
			font-weight: 600;
			font-size: 16px;
			color: #e14949;
			// background: #e14949;
			.num {
				position: relative;
				z-index: 99999;
			}
			&::before {
				content: " ";
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background-color: #ffefef;
			}
		}
		.out-limit {
			position: relative;
			z-index: 99999;
		}
		.subjectTime {
			font-weight: 600;
			font-size: 16px;
			color: #4991e1;
			margin-bottom: 2px;
		}
		.pagination {
			text-align: center;
			margin-top: 30px;
		}
		.teacherName {
			font-size: 16px;
		}
		.timeOnWeek {
			font-size: 14px;
			color: #9e9e9e;
		}
		.to-detail {
			cursor: pointer;
		}
		::v-deep .el-date-editor.el-input,
		.el-date-editor.el-input__inner {
			width: 166px;
		}
		::v-deep .el-form-item__label {
			color: #333;
			text-align: left;
		}
		::v-deep .el-form--inline .el-form-item {
			margin-right: 0;
		}
		::v-deep .el-button--small,
		.el-button--small.is-round {
			padding: 9px 26px;
		}
		::v-deep .el-form .el-input__inner {
			width: 165px;
			height: 32px;
			border-radius: 3px;
			background: #fff;
			border: 1px solid #ddd;
		}

		::v-deep .el-table__header tr th {
			background: #f7f7f7;
			box-shadow: 0px 1px 0px #eaeaea;
		}

		::v-deep .el-date-editor .el-range-separator {
			line-height: 22px;
		}

		::v-deep .el-table__header tr th {
			background: #fafafa;
			text-align: center;
		}
		::v-deep .el-table th.el-table__cell > .cell {
			padding: 10px 5px;
		}
		::v-deep .el-table th.el-table__cell > .cell {
			padding: 0 5px;
		}
		::v-deep .el-table th.el-table__cell {
			padding: 0;
		}
		::v-deep .el-table th.sub-title.el-table__cell {
			border-top: 0;
			padding-bottom: 1.5px;
			font-weight: normal;
			font-size: 12px;
			color: #7a8da2;
		}
		::v-deep .el-table th.top-title.el-table__cell {
			border-bottom: 0;
			padding-top: 1.5px;
			font-weight: normal;
			color: #7a8da2;
		}
		::v-deep th.first-title {
			font-weight: normal;
			color: #7a8da2;
		}

		::v-deep .el-table tbody td.el-table__cell {
			padding: 15px 0;
			&.isOutLimit {
				background: #ffefef;
			}
		}
		::v-deep .el-table {
			color: #666;
		}
		::v-deep .el-table--border::after,
		.el-table--group::after {
			width: 0;
		}
	}
</style>
